import colors from '@/design/colors';
import { HeadingSmall } from '@/design/typography';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  row-gap: 16px;
`;

export const Title = styled.h2`
  color: ${colors.blackAlpha200};

  /* Heading Small 16 */
  ${HeadingSmall(16)}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const ItemIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;

export const ItemTitle = styled.div`
  /* Heading Small 14 */
  ${HeadingSmall(14)}

  color: ${colors.gray100};

  padding: 8px 0;
`;

export const Item = styled.div<{ active?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 11px;
  align-self: stretch;

  ${props =>
    props.active &&
    css`
      ${ItemTitle} {
        color: ${colors.blackAlpha200};
      }

      ${ItemIcon} {
        border-radius: 4px;
        background: ${colors.gray50};
      }
    `};

  ${props =>
    !props.active &&
    css`
      color: ${colors.gray100};

      ${ItemIcon} {
        background-color: ${colors.white};
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23D9DBE3FF' stroke-width='4' stroke-dasharray='10%2c 6%2c 10%2c 8' stroke-dashoffset='40' stroke-linecap='square'/%3e%3c/svg%3e");
        border-radius: 4px;
      }
    `};
`;
